// @flow
export default function radToDeg(radians: number): number {
    return radians * 180 / Math.PI;
}